import React, { useState, useEffect } from 'react'
import '../Styles/Projects.css'
import Projectpop from '../components/Projectpop'
import axios from 'axios'
import { useNavigate } from 'react-router';
export default function Aggrements() {
    const [data, setData] = useState([
        // { project_name: 'name1 VeryLongName', project_mebers: [], customer: 'name1 VeryLongName', flyxavi_approved_coast: 450, cur: 'INR', no_of_resources: 10, status: 'TODO' },
    ])
    var tempdat = [
        { project_name: 'name1 VeryLongName', project_mebers: [], customer: 'name1 VeryLongName', flyxavi_approved_coast: 450, cur: 'INR', no_of_resources: 10, status: 'TODO' },
    ];
    const check = async () => {
    }
    const getContracts = async () => {
        await axios.get(`${process.env.REACT_APP_API_URL1}/${type == 'HR' ? 'hr/agreement/':'consultant/Agrrement_module/'}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `JWT ${localStorage.getItem('access')}`,
                'Accept': 'application/json'
            }
        })
            .then(response => {
                console.log(response.data)
                setData(response.data)
                setLoad(false)
            }).catch(err => {
                if(err.response.status==500){
                    try {
                        notify.innerHTML += `<div style="background-color:#f8d7da;color:#721c24" class='notifyUser'>
                        Server busy, Please try after some time
                        </div>`;
                        setTimeout(() => {
                            notify.removeChild(notify.lastChild)
                        }, 3000);
                    } catch (e) { console.log(e) }
                }
                let notify = document.getElementsByClassName('noti')[0];
                notify.innerHTML += `<div style="background-color:#f8d7da;color:#721c24" class='notifyUser'>
                                ${err.response.data.message}
                            </div>`;
                setTimeout(() => {
                    notify.removeChild(notify.lastChild)
                }, 3000);
                console.log(err)
                setLoad(false)
            })
    }
    useEffect(async () => {
        await getContracts()
    }, [])
    let navigate = useNavigate();
    let type=localStorage.getItem('type');
    function TabRen() {
        const list=[]
        for (let i = 0; i < 20; i++) {
            list.push(
                <tr>
                    <td class="loadingt">
                        <div class="bar"></div>
                    </td>
                    <td class="loadingt">
                        <div class="bar"></div>
                    </td>
                    <td class="loadingt">
                        <div class="bar"></div>
                    </td>
                    <td class="loadingt">
                        <div class="bar"></div>
                    </td>
                    <td class="loadingt">
                        <div class="bar"></div>
                    </td>
                </tr>
            )
        }
        return (
            <>
                {list}
            </>
        )
    }
    const [load,setLoad]=useState(true)
    return (
        type=='CONSULTANT'||type=='HR'?<>
            <div className='showdet'>
                <div className='sticky'></div>
                <div className='sticky2'>
                {type=='HR'?<Projectpop callBack={getContracts} path='agreements' />:<></>}
                </div>
            </div>
            <div className='showdet filter showfil'>
                <div className='sticky'></div>
                <div className='sticky2'>
                    <div className='projDetI Projects'>
                        <i onClick={() => { check(); 
                            document.getElementsByClassName('showfil')[0].classList.remove('show_hide')
                            }} style={{ color: 'white', marginBottom: '30px' }} class="fas fa-times"></i>
                        
                    </div>
                </div>
            </div>
            <div className='Projects top'>
                <div className='ProjectsTop row'>
                    <div className="projleft">Agreements</div>
                    <div className="projright row">
                    {type=='HR'?<button onClick={() => document.getElementsByClassName('showdet')[0].classList.add('show_hide')} >CREATE</button>:<></>}
                        {/* <div onClick={() => document.getElementsByClassName('showfil')[0].classList.add('show_hide')} className='column'>
                            <svg width="20" height="6" viewBox="0 0 20 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10 5C14.9706 5 19 4.10457 19 3C19 1.89543 14.9706 1 10 1C5.02944 1 1 1.89543 1 3C1 4.10457 5.02944 5 10 5Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 1C1 3.23 4.871 7.674 6.856 9.805C7.58416 10.5769 7.99291 11.5959 8 12.657V18L12 16V12.657C12 11.596 12.421 10.582 13.144 9.805C15.13 7.674 19 3.231 19 1" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div> */}
                    </div>
                </div>
                {/* <div className='filterList'>
                    <div className='filterBox'>TODO<i onClick={() => document.getElementById('onecheck').value = false} class="fas fa-times"></i></div>
                </div> */}
                <div>
                    <table>
                        <tr>
                            <th>DATE</th><th>FILE</th>
                        </tr>
                        {!load ? data.map((dat) => {
                            return <tr>
                                <td>{dat.date}</td>
                                <td ><span style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }} onClick={() => window.open(process.env.REACT_APP_API_URL1 + dat.file, "File View", `popup,height=700,width=1000`)} >View</span></td>
                            </tr>
                        }):<><TabRen/></>}
                    </table>
                </div>
            </div>
        </>:<></>
    )
}
